import { Component, Input,  ElementRef, ViewChildren, QueryList, HostListener } from "@angular/core";
import { Subscription } from "rxjs";
import { ActivatedRoute } from '@angular/router'
import { CommonService } from "@app/services/common.service";
import { c_components } from "../../..";
import { Helper } from "../../../../../4services/2helper";
import ims from '../../imports';

@Component({
    selector: "c_dtable_mp_session_code_detail_component",
    templateUrl: "./c_dtable_mp_session_code_detail_component.html",
    styleUrls: ["../../common.scss", "../mp_session_code_settings.scss"],
    standalone: false
})
export class c_dtable_mp_session_code_detail_component {
  // ------------------------------------------------------------------------
  @ViewChildren('actionMenus', {read: ElementRef}) actionMenus: QueryList<any>
  @Input() private resolutionCode: any;

  isLoading: boolean = false;
  tableHeader = [
    { name: 'Type', value: null, width: "20%" },
    { name: '', value: null, width: "10%" },
  ]
  resolutionCodeId = null;
  responseNoteList = [];

  // permission
  hasUpdatePermission = false;
  hasDeletePermission = false;

  constructor(
    private helper: Helper, 
    private c_components: c_components, 
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {}

  private resolutionCodes$w: Subscription;
  watch(){
    this.resolutionCodes$w = this.helper.mp_sessions.resolutionCodes$w().subscribe((v) => this.on_change_value(v));
  }

  unwatch(){
    this.resolutionCodes$w?.unsubscribe();
  }

  async ngOnInit(){
    this.isLoading = true;
    this.route.paramMap.subscribe((params) => {
      this.resolutionCodeId = +params.get('id')
    })
    await this.checkPermission();
    this.watch();
    this.responseNoteList = this.resolutionCode?.responses;
    if(!this.resolutionCode || !this.resolutionCode?.length) {
      await this.loadResponseNoteList()
    }
  }

  ngOnDestroy() {
    this.unwatch();
  }

  async checkPermission(){
    await this.helper.permission.load_my_permissions_only_if_not_loaded()
    this.hasUpdatePermission = this.helper.permission.has('dealer_mp_session_response_update')
    this.hasDeletePermission = this.helper.permission.has('dealer_mp_session_response_delete')
  }

  async loadResponseNoteList(){
    try {
      await this.helper.mp_sessions.load_mp_session_resolution_codes();
    } catch(err) {
      this.isLoading = false;
    }
  }

  on_change_value(v){
    if(!v || !v?.length) return this.isLoading = false;
    this.responseNoteList = this.helper.mp_sessions.responseNoteList(this.resolutionCodeId);
    this.isLoading = false;
  }

  // ------------------------------------------------------------------------
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.actionMenus) {
      const actionMenus = this.actionMenus.toArray();
      actionMenus.forEach(actionMenu => {
        this.responseNoteList?.forEach(note=> {
          if (('target-'+note?.response_id) === (actionMenu.nativeElement.id+'')) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              note['isShowMenu'] = false;
            }
          }
        })
      })
    }
  }

  // ------------------------------------------------------------------------
  determineElementToShow(){
    if(this.isLoading) return false
    if(!this.responseNoteList?.length) return 'no-data'
    return 'normal'
  } 

  setMorePosition(target) {
    const docElem = document.documentElement
    let elem = document.getElementById('target-'+target);
    let more = document.getElementById('target-more-'+target);
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right + 5
    const posY = rect.top - 22;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }

  toggleMenu(note){
    const targetMenu = note.isShowMenu;
    note.isShowMenu = !targetMenu;
  }

  // ---------------------------------------------------------
  openEditDialog(event, note){
    event.stopPropagation();
    note['isShowMenu'] = false;
    this.c_components.dialog.open("mp_session_code", { code_id: this.resolutionCodeId, response: note })
  }
  openDeleteDialog(event, note){
    event.stopPropagation();
    note['isShowMenu'] = false;

    this.c_components.dialog.open("warning", {
      header: 'Delete Response Note',
      contents: `
        <p>
        Are you sure you want to delete the Response Note '${note.name}'?
        </b></p>
      `,
      submit_btn: "Confrim",
      submit_class: ["button-danger"],
      icon: 'warning',
      isConfirm: false,
      color: 'orange',
      submit_func: async () => await this.deleteResponseNote(note),
    })
  }

  async deleteResponseNote(note){
    try {
      this.isLoading = true;
      const response_id = note?.response_id;
      if(!response_id) {
        this.isLoading = false;
        return
      }

      this.helper.mp_sessions.delete_mp_session_response(response_id);
      await ims.tool.sleep(300);
      this.helper.mp_sessions.load_mp_session_resolution_codes();
      this.isLoading = false;
      this.commonService.showSuccessToast('Delete response note', 'Success')
    } catch(err) {
      this.isLoading = false;
    }
  }
}
